/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PublicBasicSoftphoneUnregisterDevice$Params {
  username: string;
  password: string;

/**
 * This is the application ID to use along with the pushToken
 */
  pushAppId: string;

/**
 * This is the identifier needed by Apple and Google push notification services to deliver the push to the specific device and app
 */
  pushToken: string;

/**
 * This parameter uniquely identifies the account
 */
  selector: string;

/**
 * Acrobits device name
 */
  userAgent: string;
}

export function publicBasicSoftphoneUnregisterDevice(http: HttpClient, rootUrl: string, params: PublicBasicSoftphoneUnregisterDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
  const rb = new RequestBuilder(rootUrl, publicBasicSoftphoneUnregisterDevice.PATH, 'get');
  if (params) {
    rb.query('username', params.username, {});
    rb.query('password', params.password, {});
    rb.query('pushAppId', params.pushAppId, {});
    rb.query('pushToken', params.pushToken, {});
    rb.query('selector', params.selector, {});
    rb.query('userAgent', params.userAgent, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      }>;
    })
  );
}

publicBasicSoftphoneUnregisterDevice.PATH = '/api/public-basic-softphone/unregister-device';
